import React, { Component } from "react";
import {
    NavBar,
    Icon,
    List,
    Button,
    WhiteSpace,
    WingBlank,
    Toast,
    ActionSheet,
    Modal,
    Radio,
} from "antd-mobile";
import "./adminDetail.scss";
import axios from "../../../service/axios";
import { connect } from "dva";
const Item = List.Item;
const RadioItem = Radio.RadioItem;
const loginAdminMsg =
    sessionStorage.getItem("loginMsg") &&
    JSON.parse(sessionStorage.getItem("loginMsg"));
console.log('loginAdminMsg', loginAdminMsg)
@connect(({ app, admin }) => ({ app, admin }))
export class AdminDetails extends Component {
    state = {
        adminInfoDatas: {},
        adminUser: {},
        baseAvailInfo: {},
        loginAdminMsg: {},
        renewData: {},
        modal1: false,
        years: 3,
    };
    componentDidMount() {
        const { dispatch } = this.props;
        this.getAdminInfo();
        setTimeout(() => {
            dispatch({
                type: "app/getCurrencyCountOfAdmin",
                payload: Array.of(loginAdminMsg.id),
            });
        }, 800);
        // 延时800ms查询，防止后台接口操作太频繁
        setTimeout(() => {
            dispatch({
                type: "admin/getCurrencyCount",
                payload: Array.of(this.props.match.params.id),
            });
        }, 1600);
    }
    getAdminInfo() {
        axios
            .get("/api/user/admin/find/login_name", {
                params: {
                    loginName: this.props.match.params.name,
                },
            })
            .then(res => {
                if (res && res.status == 200 && res.data) {
                    this.setState({
                        adminInfoDatas: res.data,
                        adminUser: res.data,
                        baseAvailInfo: res.data.baseAvailInfo,
                    });
                }
            });
    }
    handleRetrieve() {
        const BUTTONS = ["确定", "取消"];
        ActionSheet.showActionSheetWithOptions(
            {
                options: BUTTONS,
                message: "确定回收管理员吗？",
                maskClosable: true,
            },
            buttonIndex => {
                if (!buttonIndex) {
                    axios
                        .get("/api/user/admin/retrieve", {
                            params: {
                                adminId: this.props.match.params.id,
                            },
                        })
                        .then(res => {
                            if (res) {
                                if (res.status == 200) {
                                    Toast.success(res.message, 1, () => {
                                        this.props.history.goBack();
                                    });
                                } else {
                                    Toast.fail(res.message, 1);
                                }
                            }
                        });
                }
            },
        );
    }
    deleteUser() {
        const BUTTONS = ["确定", "取消"];
        ActionSheet.showActionSheetWithOptions(
            {
                options: BUTTONS,
                message: "是否删除该管理员？",
                maskClosable: true,
            },
            buttonIndex => {
                if (!buttonIndex) {
                    axios
                        .get("/api/user/admin/delete", {
                            params: {
                                id: this.props.match.params.id,
                            },
                        })
                        .then(res => {
                            if (res) {
                                if (res.status == 200) {
                                    Toast.success(res.message, 1, () => {
                                        this.props.history.goBack();
                                    });
                                } else {
                                    Toast.fail(res.message, 1);
                                }
                            }
                        });
                }
            },
        );
    }
    showModal = key => (e) => {
        e.preventDefault(); // 修复 Android 上点击穿透
        axios
            .get("/api/user/admin/validYears/get", {
                params: {
                    targetId: this.props.match.params.id,
                },
            })
            .then(res => {
                if (res && res.status == 200 && res.data) {
                    this.setState({
                        years: res.data,
                    });
                }
            });
        this.setState({
            modal1: true,
        });
    }
    onClose = key => () => {
        this.setState({
            modal1: false,
        });
    }
    onChange = (years) => {
        console.log('checkbox');
        this.setState({
            years,
        });
    }
    setYears = e => () => {
        this.onClose()();
        axios
            .get("/api/user/admin/validYears/set", {
                params: {
                    targetId: this.props.match.params.id,
                    years: this.state.years,
                },
            })
            .then(res => {
                if (res) {
                    if (res.status == 200) {
                        Toast.success(res.message, 1, () => {
                            this.props.history.goBack();
                        });
                    } else {
                        Toast.fail(res.message, 1);
                    }
                }
            });
    }
    removeFreeze = id => () => {
        const BUTTONS = ["确定", "取消"];
        ActionSheet.showActionSheetWithOptions(
            {
                options: BUTTONS,
                message: "是否解除该管理员冻结？",
                maskClosable: true,
            },
            buttonIndex => {
                if (!buttonIndex) {
                    axios
                        .get("/api/user/admin/removeFreeze", {
                            params: {
                                id,
                            },
                        })
                        .then(res => {
                            if (res) {
                                if (res.status == 200) {
                                    Toast.success(res.message, 1, () => {
                                        this.props.history.goBack();
                                    });
                                } else {
                                    Toast.fail(res.message, 1);
                                }
                            }
                        });
                }
            },
        );
    }
    render() {
        const { adminInfoDatas, adminUser } = this.state;
        const { match, app, admin } = this.props;
        const { currencyTotalCount, currencyUsedCount } = app;
        const { adminCurrencyCount } = admin;

        return (
            <div className="addAdmin">
                <div className="header-sticky header-navbar">
                    <NavBar
                        icon={<Icon type="left" />}
                        onLeftClick={() => this.props.history.goBack()}
                    >
                        {match.params.name}
                        详情
                    </NavBar>
                </div>
                <div className="sub-container">
                    <form>
                        <List
                            renderHeader={`当前登录管理员${loginAdminMsg.loginName}总虚拟币数`}
                        >
                            <Item extra={currencyTotalCount}>总的币数</Item>
                            <Item
                                extra={currencyTotalCount - currencyUsedCount}
                            >
                                剩余币数
                            </Item>
                            <Item extra={currencyUsedCount}>已用币数</Item>
                        </List>
                        <List renderHeader={() => "基本信息"}>
                            <Item extra={`${adminUser.loginName}`}>
                                登录账号{" "}
                            </Item>
                            <Item extra={adminInfoDatas.createBy}>
                                上级账号{" "}
                            </Item>
                            <Item extra={adminInfoDatas.password}>密码 </Item>

                            <Item extra={`${adminUser.remarks || ""}`}>
                                备注{" "}
                            </Item>
                        </List>
                        <List
                            renderHeader={() =>
                                `${adminUser.loginName}虚拟币`
                            }
                        >
                            <Item
                                extra={`${adminCurrencyCount.totalCount || 0}`}
                            >
                                总的币数{" "}
                            </Item>
                            <Item
                                extra={`${adminCurrencyCount.surplusCount || 0}`}
                            >
                                剩余币数
                            </Item>
                            <Item
                                extra={`${adminCurrencyCount.usedCount || 0}`}
                            >
                                已用币数
                            </Item>
                        </List>
                        <WhiteSpace size="lg" />
                        <WingBlank size="lg">
                            {
                                loginAdminMsg && (Number(loginAdminMsg.userType) + 1) == adminUser.userType ? (
                                    <div>
                                        <Button
                                            type="ghost"
                                            onClick={() =>
                                                this.props.history.push(
                                                    `/adminnum/${adminUser.loginName}/0/${adminUser.id}`,
                                                )
                                            }
                                        >
                                            下发币
                                        </Button>
                                        <WhiteSpace />
                                        <Button
                                            type="ghost"
                                            onClick={() =>
                                                this.props.history.push(
                                                    `/adminnum/${adminUser.loginName}/1/${adminUser.id}`,
                                                )
                                            }
                                        >
                                            回收币
                                        </Button>
                                        <WhiteSpace />
                                        <Button
                                            type="primary"
                                            onClick={() =>
                                                this.props.history.push(
                                                    `/addadmin/${adminUser.loginName}/edit/${adminUser.id}`,
                                                )
                                            }
                                        >
                                            修改
                                        </Button>
                                        {(loginAdminMsg && loginAdminMsg.userType != 0) ? (
                                            <div>
                                                <WhiteSpace />
                                                <Button
                                                    type="warning"
                                                    onClick={() => this.handleRetrieve()}
                                                >
                                                    回收
                                                </Button>
                                            </div>
                                        ) : ("")}
                                    </div>) : ("")
                            }
                            {(loginAdminMsg && loginAdminMsg.userType == 3 && loginAdminMsg.preferentialMonths <= 0) ? (
                                <div>
                                    <WhiteSpace />
                                    <Button
                                        type="primary"
                                        onClick={() =>
                                            this.props.history.push(
                                                `/adminFuncRenew/${adminUser.id}`,
                                            )
                                        }
                                    >
                                        续费
                                    </Button>
                                </div>
                            ) : ("")}
                            {loginAdminMsg && loginAdminMsg.userType == 3 ? (
                                <div>
                                    <WhiteSpace />
                                    <Button
                                        type="primary"
                                        onClick={() =>
                                            this.props.history.push(
                                                `/funcDetail/admin/${adminUser.id}`,
                                            )
                                        }
                                    >
                                        功能组
                                    </Button>
                                </div>
                            ) : ("")}
                            <WhiteSpace />
                            {(loginAdminMsg && loginAdminMsg.userType == 3 && loginAdminMsg.preferentialMonths > 0) ? (
                                <div>
                                    <Button onClick={this.showModal()}>年限设置</Button>
                                    <WhiteSpace />
                                    <Button onClick={() =>
                                        this.props.history.push(
                                            `/adminPermission/${adminUser.id}`,
                                        )
                                    }>
                                        权限设置
                                    </Button>
                                    <WhiteSpace />
                                    <Button onClick={() =>
                                        this.props.history.push(
                                            `/transferUsers/${adminUser.loginName}/${adminUser.id}`,
                                        )
                                    }>
                                        迁移用户
                                    </Button>
                                    <WhiteSpace />
                                </div>
                            ) : ("")}
                            {(loginAdminMsg && loginAdminMsg.userType == 0 && (Number(loginAdminMsg.userType) + 1) == adminUser.userType) ? (
                                <div>
                                    <Button onClick={() =>
                                        this.props.history.push(
                                            `/assignFuncGroup/${adminUser.id}`,
                                        )
                                    }>
                                        分配功能组
                                    </Button>
                                    <WhiteSpace />
                                </div>
                            ) : ("")}
                            {(loginAdminMsg && loginAdminMsg.userType == 0) ? (
                                <div>
                                    <Button
                                        disabled={this.props.match.params.flag != '4'}
                                        onClick={() => this.removeFreeze(adminUser.id)()}
                                    >
                                        解冻
                                    </Button>
                                    <WhiteSpace />
                                </div>
                            ) : ("")}
                            <WhiteSpace />
                            {/* <WhiteSpace />
                            <Button
                                type="warning"
                                onClick={() => this.deleteUser()}
                            >
                                删除
                            </Button> */}
                        </WingBlank>
                        <WhiteSpace size="lg" />
                        <WhiteSpace size="lg" />
                        <Modal
                            visible={this.state.modal1}
                            transparent
                            maskClosable={false}
                            onClose={this.onClose()}
                            title="管理员年限设置"
                            footer={[{ text: '取消', onPress: () => this.onClose()() }, { text: '确定', onPress: () => this.setYears()() }]}
                            wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                        >
                            <div style={{ height: 100, overflow: 'scroll' }}>
                                <List>
                                    <RadioItem key={1} checked={this.state.years == 1} onChange={() => this.onChange(1)}>1年</RadioItem>
                                    <RadioItem key={2} checked={this.state.years == 3} onChange={() => this.onChange(3)}>3年</RadioItem>
                                </List>
                            </div>
                        </Modal>
                    </form>
                </div>
            </div>
        );
    }
}

export default AdminDetails;
